import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	list: [],
	selected: null,
	fetch: false,
	params: {
		offset: 0,
		limit: 100,
	},
};

const languageSlice = createSlice({
	name: "language",
	initialState,
	reducers: {
		getList: (state) => {
			state.fetch = true;
		},
		setList: (state, action) => {
			state.list = action.payload;
			state.fetch = false;
		},
		select: (state, action) => {
			state.selected = action.payload;
		},
		drop: () => initialState,
	},
});

export const languageActions = languageSlice.actions;
export const languageReducer = languageSlice.reducer;
